import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import { compact, filter, flatMap, includes, map, uniq } from 'es-toolkit/compat';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';

import { AnnotationAssignment, AnnotationWorkingStates, AnnotationWorkingStateValues } from 'interfaces/annotation';
import { humanize } from 'utils/helpers';
import { filterAnnotationAssignments } from './helpers';
import { IFormValues } from './types';

interface Props {
  formMethods: UseFormReturn<Partial<IFormValues>, any>;
  annotationAssignments: AnnotationAssignment[];
}

export const SelectSlidesByWorkingState: React.FC<Props> = ({ formMethods, annotationAssignments }) => {
  const { watch } = formMethods;

  const selectedAssignmentIds = watch('annotationAssignmentIds');
  const workingStatesToUse = (watch('workingStatesToUse') as AnnotationWorkingStates[]) || [];

  return (
    <Grid item>
      {map(AnnotationWorkingStateValues, (option) => {
        const isUsed = includes(workingStatesToUse, option);
        return (
          <Grid container item xs={12} alignItems="center" key={option} ml={6}>
            <Grid item>
              <FormControlLabel
                label={humanize(option)}
                control={
                  <Checkbox
                    checked={isUsed}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                      const newWorkingStates = checked
                        ? uniq([...workingStatesToUse, option])
                        : filter(workingStatesToUse, (state) => state !== option);
                      formMethods.setValue('workingStatesToUse', newWorkingStates);
                      const filteredAnnotationAssignments = filterAnnotationAssignments({
                        annotationAssignments,
                        selectedAssignmentIds,
                        workingStatesToUse: newWorkingStates,
                      });
                      const newSlideIds = uniq(
                        compact(
                          flatMap(filteredAnnotationAssignments, ({ annotations }) => map(annotations, 'slideId'))
                        )
                      );
                      formMethods.setValue('slideIds', newSlideIds);
                    }}
                  />
                }
              />
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};
